import { CircularProgress } from '@mui/material';
import React from 'react';

import * as Styled from './delete-goal-loading.style';

export const DeleteGoalLoading: React.FC = () => (
  <Styled.Container>
    <CircularProgress />
  </Styled.Container>
);
